import { gql } from 'graphql-request'

export const GET_POSITION_HISTORY = gql`
  query positionHistory($tokenId: String!) {
    positionSnapshots(where: { position: $tokenId }, orderBy: timestamp, orderDirection: desc, first: 30) {
      id
      transaction {
        mints(where: { or: [{ amount0_gt: "0" }, { amount1_gt: "0" }] }) {
          id
          timestamp
          amount1
          amount0
          logIndex
        }
        burns(where: { or: [{ amount0_gt: "0" }, { amount1_gt: "0" }] }) {
          id
          timestamp
          amount1
          amount0
          logIndex
        }
        collects(where: { or: [{ amount0_gt: "0" }, { amount1_gt: "0" }] }) {
          id
          timestamp
          amount0
          amount1
          logIndex
        }
      }
    }
  }
`
